import React from "react";
import "./BlogCard.scss";

export default function BlogCard({
  data: {title, url, brief, publishedAt, slug, coverImage},
  blog,
  isDark
}) {
  const imgPath = coverImage?.url || coverImage;

  function openUrlInNewTab(url, name) {
    if (!url) {
      console.log(`URL for ${name} not found`);
      return;
    }
    var win = window.open(url, "_blank");
    win.focus();
  }

  return (
    <div onClick={() => openUrlInNewTab(url, title)}>
      <div className={isDark ? "blog-container dark-mode" : "blog-container"}>
        <div
          className={
            isDark ? "dark-mode blog-card blog-card-shadow" : "blog-card"
          }
        >
          {imgPath ? (
            <div className="blog-image-container">
              <img
                src={imgPath}
                alt={title}
                className="blog-image"
                loading="lazy"
                onError={e => {
                  e.target.style.display = "none";
                  e.target.parentElement.style.display = "none";
                }}
              />
            </div>
          ) : (
            <div className="blog-image-container blog-image-placeholder">
              <div className="placeholder-content">
                <span className="placeholder-icon">📝</span>
              </div>
            </div>
          )}

          <div className="blog-content">
            <h3 className={isDark ? "small-dark blog-title" : "blog-title"}>
              {title}
            </h3>

            <p className={isDark ? "small-dark blog-brief" : "blog-brief"}>
              {brief}
            </p>
          </div>

          <div className="go-corner">
            <div className="go-arrow">→</div>
          </div>
        </div>
      </div>
    </div>
  );
}
